<template>
  <div :class="['el-input']">
    <span v-if="prefix" class="input-prefix">
      {{ prefix }}
    </span>
    <input
      type="text"
      ref="numberInput"
      :class="['el-input__inner', { 'with-prefix': prefix }]"
      :readonly="computedReadOnly"
      :maxlength="maxLength"
      :id="id"
      :name="name"
      v-model="storedValue"
      :placeholder="placeholder"
      @blur="onBlur"
      @focus="onFocus"
      @keyup.enter="handleEnterKey"
      @keyup.esc="handleEscapeKey"
    />
    <span v-if="suffix" class="input-suffix">
      {{ suffix }}
    </span>
  </div>
</template>

<script>
import mixinNumberInput from '../../../utils/mixin-number-input'

/**
 * @class NumberInput
 *
 * @description This component is the state handler/wrapper for NumberInput
 */

export default {
  name: 'NumberInput',
  mixins: [mixinNumberInput],
  props: {
    name: {
      type: String,
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    readOnly: {
      type: Boolean,
    },
    isSavable: {
      type: Boolean,
    },
  },
  data() {
    return {
      isEnterPressed: false,
    }
  },
  methods: {
    setValue(value) {
      const numberInput = this.$refs.numberInput
      this.cursorPosition = numberInput.selectionStart - 1
      this.$emit('form-item-changed', { value: value ? this.getParsedValue(value) : '' })
    },
    handleEnterKey(event) {
      this.onBlur(event)
      this.isEnterPressed = true
      this.$emit('set-table-loader', true)
      if (this.canSave(this.isSavable)) this.handleOnEnterSave()
    },
    handleEscapeKey() {
      this.$emit('keyup-escape')
    },
    canSave(isSavable) {
      return this.isEnterPressed && isSavable
    },
    handleOnEnterSave() {
      this.$emit('keyup-enter')
      this.isEnterPressed = false
      this.$dispatch('setIsSavable', { isSavable: false })
    },
  },
  watch: {
    isSavable: {
      handler(isSavable) {
        if (this.canSave(isSavable)) this.handleOnEnterSave()
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
[readonly] {
  background: $background-color-readonly !important;
  cursor:
    url('../../../assets/img/notallowed24.png') 2 2,
    not-allowed !important;
}
.el-input {
  position: relative;
}
.with-prefix {
  padding-left: 32px;
}
.input-prefix,
.input-suffix {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.input-prefix {
  left: 10px;
}
.input-suffix {
  right: 10px;
}
</style>
